<p-button [label]="buttonText()" [icon]="isDark() ? 'pi pi-sun' : 'pi pi-moon'" size="small" (onClick)="toggleDarkMode()" />
